<template>
  <div>
    <!-- menu button -->
    <OButton
      ref="profilePopperTrigger"
      pure
      class="
        w-10
        h-10
        u-center
        ml-auto
        text-primary-200
        rounded-full
        sm:hover:bg-alpha-5 sm:hover:text-o-blue
        border border-divider-[#E2E5ED]
      "
      @click="openMenu"
    >
      <OIcon icon="dots" svg-class="w-6 h-6" />
    </OButton>

    <!-- mobile menu -->
    <div
      v-if="isMobile"
      class="ProfileMenu fixed top-0 left-0 z-full-page-loading w-full h-full flex invisible opacity-0"
      :class="{ active: isActive }"
    >
      <div class="memu__overlay bg-black-50 fixed w-full h-full top-0 left-0 right-0 bottom-0" @click="closeMenu"></div>
      <div class="ProfileMenu--wrapper relative bg-white w-full mt-auto mx-auto p-4 pt-8 rounded-lg space-y-4">
        <div class="absolute u-center top-1 right-1 w-10 h-10" @click="closeMenu">
          <OIcon icon="times-light" />
        </div>
        <slot></slot>
      </div>
    </div>

    <!-- desktop menu -->
    <OPopper ref="profilePopperView" :is-visible="profilePopper.visible" class="z-1 min-w-44 w-max">
      <div v-if="profilePopper.visible" class="bg-body-primary shadow-md border border-divider-100 rounded-md py-2">
        <slot></slot>
      </div>
    </OPopper>
  </div>
</template>

<script>
import { defineComponent, ref, onUnmounted } from '@nuxtjs/composition-api';
import { OPopper, OButton, OIcon } from '@/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import { usePopper } from '~/composables/usePopper';
import { eventBus } from '~/modules/common/utils/eventBus';
export default defineComponent({
  components: {
    OPopper,
    OButton,
    OIcon,
  },
  setup() {
    const isActive = ref(false);
    const { isMobile } = useDevice();
    const [profilePopperTrigger, profilePopperView, profilePopper] = usePopper({ offset: [0, 0] });
    const unlockScroll = () => document.getElementsByTagName('body')[0].classList.remove('no-scroll');
    const lockScroll = () => document.getElementsByTagName('body')[0].classList.add('no-scroll');
    const openMenu = () => {
      if (isMobile.value) {
        lockScroll();
        isActive.value = true;
      } else {
        profilePopper.toggle();
      }
    };
    const closeMenu = () => {
      if (isMobile.value) {
        unlockScroll();
        isActive.value = false;
      } else {
        profilePopper.hide();
      }
    };
    eventBus.on('close-profile-menu', closeMenu);
    onUnmounted(() => eventBus.off('close-profile-menu', closeMenu));
    return {
      isActive,
      openMenu,
      closeMenu,
      isMobile,
      profilePopperTrigger,
      profilePopperView,
      profilePopper,
    };
  },
});
</script>

<style lang="scss" scoped>
.ProfileMenu {
  transition: all 0.3s ease;
  &.active {
    opacity: 1;
    visibility: visible;
    .ProfileMenu--wrapper {
      transform: translateY(0);
    }
  }
  &--wrapper {
    transform: translateY(100%);
    will-change: transform;
    transition: all 0.6s ease;
    transition-delay: 0.2s;
    button {
      background-color: var(--bg-body-secondary);
      border-radius: 6px;
      height: 56px;
      font-size: 14px;
    }
  }
}
</style>
